var pInfScrLoading = false;
var pInfScrDelay = 100;
 
function pInfScrExecute() {
  if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
    var loadingImage;
    pInfScrNode = $('.product#more').last();	
    pInfScrURL = $('.product#more p a').last().attr("href");
    
    if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
      
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
          
        },
        
        success: function(data) {
          // remove loading feedback
          pInfScrNode.next().remove();
          var filteredData = $($.parseHTML(data)).find(".product");         
          //alert(data);
          filteredData.insertBefore( $("#product-list-foot") );
          loadingImage.remove();					
          pInfScrLoading = false;
        },
        dataType: "html"
      });
    }
  }
}
$(document).ready(function () {
  $(window).scroll(function(){
    $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
    if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      pInfScrDelay = 100;
    }
  });
});
